module.exports = __webpack_public_path__ + "static/img/defaultUCpic.83dd413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/defaultUCpic.png
// module id = X/ii
// module chunks = 2